import React from 'react';
import { motion } from 'framer-motion';
import {
    BarChart3,
    Calendar,
    FileText,
    CalendarDays,
    TrendingUp,
    Users,
    Camera,
    MessageSquare,
    FileDown,
    Link2,
    Settings,
    UserPlus,
    Sparkles
} from 'lucide-react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../style/PricingSection.css';

const PricingSection = () => {
    const features = [
        { icon: <BarChart3 size={20} strokeWidth={2} />, text: "Dashboard & Sales Overview" },
        { icon: <Calendar size={20} strokeWidth={2} />, text: "Job Scheduling & Recurring Jobs" },
        { icon: <FileText size={20} strokeWidth={2} />, text: "Quotes, Invoices & Payments" },
        { icon: <CalendarDays size={20} strokeWidth={2} />, text: "Calendar: Day / Week / Month View" },
        { icon: <TrendingUp size={20} strokeWidth={2} />, text: "Forecasting & Debt Lists" },
        { icon: <Users size={20} strokeWidth={2} />, text: "Customers Management" },
        { icon: <Camera size={20} strokeWidth={2} />, text: "Upload Photos & Receipts" },
        { icon: <MessageSquare size={20} strokeWidth={2} />, text: "50 Monthly SMS + Rollovers" },
        { icon: <FileDown size={20} strokeWidth={2} />, text: "PDF & Excel Exports" },
        { icon: <Link2 size={20} strokeWidth={2} />, text: "QuickBooks & Xero Integration" },
        { icon: <Settings size={20} strokeWidth={2} />, text: "Company Settings & Notifications" },
        { icon: <UserPlus size={20} strokeWidth={2} />, text: "Employee Access (Add-On)" }
    ];

    const handleGetStarted = () => {
        if (window.fbq) {
      window.fbq('track', 'Lead', {
        content_name: 'Landing Page Get Started Click',
        status: 'Initiated' // Custom parameter for clarity
      });
    }
        window.open("https://web.daydone.co.uk/", "_blank");
    };


    return (
        <section className="pricing-section" id="pricing">
            <div className="container">
                <motion.div
                    className="row justify-content-center"
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6 }}
                >
                    <div className="col-lg-10">
                        <div className="pricing-card">
                            <div className="row g-0">
                                {/* Left Side - Pricing */}
                                <div className="col-md-5">
                                    <div className="pricing-left">
                                        <div className="sparkle-icon">
                                            <Sparkles size={48} strokeWidth={2} />
                                        </div>

                                        <div className="subscription-badge">
                                            Business account subscription
                                        </div>

                                        <div className="price-container">
                                            <span className="currency">£</span>
                                            <span className="amount">18</span>
                                            <span className="period">per month</span>
                                        </div>

                                        <div className="employee-pricing">
                                            + £2 per employee / month
                                        </div>
                                        <p className="pricing-note">Add as many employees as you need.</p>

                                        <button className="btn btn-primary btn-trial" onClick={handleGetStarted}>
                                            Start Your Free Trial
                                        </button>

                                        <p className="terms-text">
                                            No contract. No setup fee. Cancel anytime.
                                        </p>
                                    </div>
                                </div>

                                {/* Right Side - Features */}
                                <div className="col-md-7">
                                    <div className="features-right">
                                        <h3 className="features-title">Included in your plan:</h3>

                                        <ul className="features-list">
                                            {features.map((feature, index) => (
                                                <motion.li
                                                    key={index}
                                                    className="feature-item"
                                                    initial={{ opacity: 0, x: 20 }}
                                                    whileInView={{ opacity: 1, x: 0 }}
                                                    viewport={{ once: true }}
                                                    transition={{ delay: index * 0.05, duration: 0.4 }}
                                                >
                                                    <span className="feature-icon">{feature.icon}</span>
                                                    <span className="feature-text">{feature.text}</span>
                                                </motion.li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </motion.div>
            </div>
        </section>
    );
};

export default PricingSection;